import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlockquotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 7C4.46957 7 3.96086 7.21071 3.58579 7.58579C3.21071 7.96086 3 8.46957 3 9V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H12.5V20C12.5 21.0609 12.0786 22.0783 11.3284 22.8284C10.5783 23.5786 9.56087 24 8.5 24C7.94772 24 7.5 24.4477 7.5 25C7.5 25.5523 7.94772 26 8.5 26C10.0913 26 11.6174 25.3679 12.7426 24.2426C13.8679 23.1174 14.5 21.5913 14.5 20V9C14.5 8.46957 14.2893 7.96086 13.9142 7.58579C13.5391 7.21071 13.0304 7 12.5 7H5ZM12.5 9V17H5L5 9L12.5 9Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.5 7C18.9696 7 18.4609 7.21071 18.0858 7.58579C17.7107 7.96086 17.5 8.46957 17.5 9V17C17.5 17.5304 17.7107 18.0391 18.0858 18.4142C18.4609 18.7893 18.9696 19 19.5 19H27V20C27 21.0609 26.5786 22.0783 25.8284 22.8284C25.0783 23.5786 24.0609 24 23 24C22.4477 24 22 24.4477 22 25C22 25.5523 22.4477 26 23 26C24.5913 26 26.1174 25.3679 27.2426 24.2426C28.3679 23.1174 29 21.5913 29 20V9C29 8.46957 28.7893 7.96086 28.4142 7.58579C28.0391 7.21071 27.5304 7 27 7H19.5ZM27 9V17H19.5V9H27Z"
	})]
});
export default SvgBlockquotes;
